import React, { useEffect, useState } from "react";
import "./login.scss";
import { rightarrowwhite } from "../../images";
import CountryCodeDropdown from "../../components/CountryCodeDropdown/CountryCodeDropdown";
import FullWidthTextField from "../../components/TextField/FullWidthTextField";
import FooterV2 from "../../components/FooterV2/FooterV2";
import BlinkingDots from "../../Animations/BlinkingDots/BlinkingDots";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  designAssistantLoginOtpURL,
  privacypolicyURL,
} from "../../components/helpers/constant-words";
import config from "../../config/config";

import Joi from "joi";
import http from "../../helpers/http";
import { useWindowSize } from "react-use";
import { useAuth } from "../../context/Auth/AuthState";
import { parsePhoneNumber } from "libphonenumber-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import useTheme from "../../components/useTheme/useTheme";

const DesignAssistantLogin = () => {
  const { width } = useWindowSize();
  const { theme } = useTheme();
  const [deviceId, setDeviceId] = useState(null);
  const navigate = useNavigate();
  const [codes, setCodes] = useState([]);
  const [values, setValues] = useState({
    country_code: "91",
    phone: "",
  });

  const [formError, setFormError] = useState({});
  const joiOptions = config.joiOptions;

  const base_url = config.api_url;

  const handleChange = (e) => {
    setValues((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSelectChange = (value, fieldName) => {
    setValues((prevState) => {
      return {
        ...prevState,
        [fieldName]: value,
      };
    });
  };

  const validate = async (data) => {
    const schemaObj = {
      country_code: Joi.string().trim().required().label("Code"),
      phone: Joi.string().trim().required().label("Mobile No"),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });
    const { error } = schema.validate(data, joiOptions);

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    if (data.phone) {
      try {
        const phoneNumber = parsePhoneNumber(
          `+${values.country_code}${values.phone}`
        );

        if (phoneNumber.isValid() === false) {
          errors["phone"] = `Phone number must be valid `;
        }
      } catch (error) {}
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = await validate(values);
    setFormError(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const userProfiles = JSON.parse(
      localStorage.getItem("userProfiles") || "[]"
    );

    const profilesArray = Object.values(userProfiles);

    const personalAccounts = profilesArray.filter(
      (profile) => !("isVerified" in profile)
    ).length;
    if (personalAccounts >= 1) {
      setFormError({ country_code: "Only 1 personal account is allowed." });
      return;
    }

    values["deviceId"] = deviceId;
    const data = await http.post(base_url + "/personal/login", values);
    if (data) {
      sessionStorage.setItem("canAccessOtp", "true");
      navigate(designAssistantLoginOtpURL, {
        state: values,
      });
    }
  };

  const fetchCodes = async () => {
    try {
      const { data } = await http.get(base_url + "/general/countries/codes");
      if (data) {
        setCodes(data);
      }
    } catch (err) {
      console.error("Failed to fetch country codes:", err);
    }
  };

  useEffect(() => {
    const getFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceId(result.visitorId);
    };

    getFingerprint();
    fetchCodes();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BlinkingDots />
      <main className="user_login_container">
        <section className="login_sec1">
          <div className="my_container">
            <div className="text_container">
              <h2 className="sub_title">Login</h2>
              <h3 className={`title ${theme === "light" ? "text-black" : ""}`}>
                Login to your Personal Account
              </h3>
            </div>

            <div className="contact_wrapper">
              <form onSubmit={handleSubmit} noValidate autoComplete="on">
                <div className="row field_row">
                  <div className="col-md-12 field_col">
                    <div className="row">
                      <div className="col-4 ps-0">
                        <div
                          className={`field_wrapper ${
                            theme === "light" && "field_wrapper_light_mode"
                          }`}
                        >
                          <CountryCodeDropdown
                            lightTheme={theme === "light" ? true : false}
                            textLabel="Code"
                            data={codes}
                            onChange={(e, value) => {
                              handleSelectChange(
                                value.phone_code,
                                "country_code"
                              );
                            }}
                            defaultValue={{
                              name: "India",
                              iso3: "IND",
                              phone_code: "91",
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-8 pe-0">
                        <div
                          className={`field_wrapper ${
                            theme === "light" && "field_wrapper_light_mode"
                          }`}
                        >
                          <FullWidthTextField
                            label="Mobile No.*"
                            type="tel"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            autoComplete="phone"
                            lightTheme={theme === "light" ? true : false}
                          />
                          <p className="error">
                            {formError.country_code || formError.phone}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p
                  className={`terms_text ${
                    theme === "light" ? "text-black" : ""
                  }`}
                >
                  By continuing, you agree to {width < 600 && <br />}the terms
                  of{" "}
                  <Link
                    to={privacypolicyURL}
                    className="link clr_orange"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Archinza Policy.
                  </Link>
                </p>
                <div className="cta_wrapper">
                  <div className="btn_wrapper">
                    <button className="form_btn">
                      Login with OTP
                      <img
                        src={rightarrowwhite}
                        alt="icon"
                        className="icon"
                        loading="lazy"
                      />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        {theme === "dark" ? (
          <FooterV2 whatsappBotIcon={false} />
        ) : (
          <FooterV2 lightTheme whatsappBotIcon={false} />
        )}
      </main>
    </>
  );
};
export default DesignAssistantLogin;
